import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "./rooms.css";

const rooms = [
   {
    roomId: "DLX-101",
    title: "Deluxe Room",
    price: "2,000₹",
    img: "8.png",
    aimg: "7-1.png",
    bimg: "7-2.png",
    capacity: "2 Adult + 1 Children ",
    Ac: "Available",
    bed: "1 Double Bed",
    services: "Wifi, Television ,Fridger , hot kettle, Bathroom...",
  },
   {
    roomId: "DLX-102",
    title: "Deluxe room",
    price: "2,000₹",
    img: "6.png",
    aimg: "5-1.png",
    bimg: "5-2.png",
    capacity: "2 Adult + 1 Children",
    Ac: "Available",
    bed: "1 double bed",
    services: "Wifi, Televisionn ,Fridger , hot kettle, Bathroom...",
  },
   {
    roomId: "DLX-103",
    title: "Deluxe Room",
    price: "2,000₹",
    img: "4.png",
    aimg: "3-1.png",
    bimg: "3-2.png",
    capacity: "2 Adult + 1 Children ",
    Ac: "Available",
    bed: "1 Double Beds",
    services: "Wifi, Television ,Fridger , hot kettle, Bathroom...",
  },
   {
    roomId: "DLX-104",
    title: "Deluxe Room",
    price: "2,000₹",
    img: "11.png",
    aimg: "10-1.png",
    bimg: "10-2.png",
    capacity: "2 Adult + 1 Children",
    Ac: "Available",
    bed: "1 Double bed",
    services: "Wifi, Television ,Fridger , hot kettle, Bathroom...",
  },
  {
    roomId: "DLX-105",
    title: "Deluxe Room",
    price: "2,000₹",
    img: "12.png",
    aimg: "11-1.png",
    bimg:"11-2.png",
    capacity: "2 Adult + 1 Children",
    Ac: "Available",
    bed: "1 Double bed",
    services: "Wifi, Television ,Fridger  ,hot kettle, Bathroom...",
  },
  {
    roomId: "SDLX-101",
    title: "Super Deluxe Room",
    price: "2,300₹",
    img: "5.png",
    aimg: "4-1.png",
    bimg: "4-2.png",
    capacity: "2 Adult + 1 Children",
    Ac: "Available",
    bed: "1 double bed, Sitting Table",
    services: "kit, Wifi, Television, Bathroom...",
  },
 
  {
    roomId: "SDLX-102",
    title: "Super Deluxe Room",
    price: "2,300₹",
    img: "9.png",
    aimg: "8-1.png",
    bimg: "8-2.png",
    capacity: "2 Adult+ 1 Children ",
    Ac: "Available",
    bed: "1 Double Bed",
    services: "kit, Wifi, Television ,Hotkettle ,Fridger ,Sofa ,kit ,Bathroom...",
  },
  {
    roomId: "PRM-101",
    title: "Primium Room",
    price: "2,800₹",
    img: "13.png",
    aimg: "12-1.png",
    bimg: "12-2.png",
    capacity: "3 Adult + 1 Children",
    Ac: "Available",
    bed: "1 Double Bed ,1 Single Bed",
    services: "kit ,Hotkettle ,Fridger ,hair dryer ,breakfast, Wifi, Television, Bathroom...",
  },
  {
    roomId: "SPRM-101",
    title: "Super Primium Room",
    price: "3,000₹",
    img: "10.png",
    aimg: "9-1.png",
    bimg: "9-2.png",
    capacity: "3 Adult + 1 Children",
    Ac: "Available",
    bed: "1 Double Bed ,1 Single Bed ",
    services: "kit , Breakfast, Wifi, Television, Sofa, Bathroom...",
  },
  {
    roomId: "SPRM-102",
    title: "Super Primium Room",
    price: "3,000₹",
    img: "7.png",
    aimg: "6-1.jpeg",
    bimg: "6-2.png",
    capacity: "3 Adult+ 1 Children",
    Ac: "Available",
    bed: "1 double + 1 single bed",
    services: "kit, Wifi, Television ,hotkettle, fridger ,hairdryer ,Sofa with tea table, Bathroom...",
  },
  {
    roomId: "STE-101",
    title: "Suite Room",
    price: "4,500₹",
    img: "2.png",
    aimg: "1-1.png",
    bimg: "1-2.png",
    capacity: "2 Adult + 1 Children",
    Ac: "Available",
    bed: "1 double bed, Sofa",
    services: "Kit, Breakfast, hotkettle, hairdryer, fridger ,Wifi, Television, Bathroom...",
  },
  {
    roomId: "STE-102",
    title: "Suite room",
    price: "5,500₹",
    img: "3.png",
    aimg: "2-1.png",
    bimg: "2-2.png",
    capacity: "2 Adult + 1 Childern",
    Ac: "Available",
    bed: "1 Double bed, Sofa",
    services: "Kit, Breakfast, hotkettle ,hairdryer, fridger ,Television, Bathroom...",
  },
];


const Rooms = () => {
  const roomsRef = useRef(null);

  useEffect(() => {
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          roomsRef.current.classList.add("show");
        }
      },
      { threshold: 0.2 }
    );

    if (roomsRef.current) observer.observe(roomsRef.current);
    return () => observer.disconnect();
  }, []);

//   useEffect(() => {
//   const container = roomsRef.current;

//   const handleWheel = (e) => {
//     if (container) {
//       e.preventDefault();
//       container.scrollLeft += e.deltaY;
//     }
//   };

//   if (container) {
//     container.addEventListener("wheel", handleWheel, { passive: false });
//   }

//   return () => {
//     if (container) {
//       container.removeEventListener("wheel", handleWheel);
//     }
//   };
// }, []);


useEffect(() => {
  const slider = roomsRef.current;
  let isDown = false;
  let startX;
  let scrollLeft;

  if (!slider) return;

  const handleMouseDown = (e) => {
    isDown = true;
    slider.classList.add("active");
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  };

  const handleMouseLeave = () => {
    isDown = false;
    slider.classList.remove("active");
  };

  const handleMouseUp = () => {
    isDown = false;
    slider.classList.remove("active");
  };

  const handleMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2; // speed multiplier
    slider.scrollLeft = scrollLeft - walk;
  };

  slider.addEventListener("mousedown", handleMouseDown);
  slider.addEventListener("mouseleave", handleMouseLeave);
  slider.addEventListener("mouseup", handleMouseUp);
  slider.addEventListener("mousemove", handleMouseMove);

  return () => {
    slider.removeEventListener("mousedown", handleMouseDown);
    slider.removeEventListener("mouseleave", handleMouseLeave);
    slider.removeEventListener("mouseup", handleMouseUp);
    slider.removeEventListener("mousemove", handleMouseMove);
  };
}, []);


  return (
    <div id="rooms" className="rooms-container" ref={roomsRef}>

      {rooms.map((room, index) => (
        <div className="room-card" key={index}>
          <img src={room.img} alt={room.title} />

          {/* DEFAULT CONTENT */}
          <div className="room-basic">
            <h3>{room.title}</h3>
            <p>
              <span>{room.price}</span>/Pernight
            </p>
          </div>

          {/* HOVER CONTENT */}
          <div className="room-hover">
            <h3>{room.title}</h3>
            <p className="price">
              <span>{room.price}</span>/Pernight
            </p>

            <ul>
              <li>
                <b>Ac:</b> {room.Ac}
              </li>
              <li>
                <b>Capacity:</b> {room.capacity}
              </li>
              <li>
                <b>Bed:</b> {room.bed}
              </li>
              <li>
                <b>Services:</b> {room.services}
              </li>
            </ul>

            {/* ✅ Link-based navigation */}
            <Link
              to="/room-details"
              state={{ room }}
              style={{ textDecoration: "none" }}
            >
              <button>VIEW DETAILS</button>
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Rooms;
